import React, { useState, useRef } from "react";

import {
  Typography,
  Button,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import { ReactComponent as ImportIcon } from "../../../images/commonicon/importicon.svg";
import { ReactComponent as QuestionIcon } from "../../../images/questionimage/questionicon.svg";
import { toast } from "react-toastify";
import bulkQuestions from "../../../../Bulk_center_feedback_questions.csv";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { ReactComponent as ExportIcon } from "../../../images/commonicon/exporticon.svg";
import { useParams } from "react-router-dom";
import Loader from "../../../CustomComponent/Loader";

function PageHeader({ questionList, examName, fetchData }) {
  const classes = useStyles();


  const { rowId } = useParams();

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [loaderOpen, setLoaderOpen] = useState(false);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = bulkQuestions;
    link.setAttribute("download", "Sample_BulkFeeback.csv");

    // Append to the document and trigger the download
    document.body.appendChild(link);
    link.click();

    // Check if the download started (link exists in document)
    if (document.body.contains(link)) {
      toast.success(
        "Sample file for adding center feedback questions in bulk has been downloaded",
      );
    } else {
      toast.error(
        "Failed to download the bulk questions file. Please try again.",
      );
    }

    // Clean up
    link.parentNode.removeChild(link);
  };

  const fileInputRef = useRef();

  const handleFileInputChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();

    formData.append("file", file);

    formData.append("exam_id", rowId);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/center_feedback/import`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        toast.success("Questions uploaded successfully");
        fetchData();
      } else {
        throw new Error("Failed to upload questions");
      }
    } catch (error) {
      fetchData();
      toast.error(
        error.response?.data?.message ||
          "An error occurred while uploading questions",
      );
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const [fileURL, setFileURL] = useState("");
  // const exportApi = async (decryptedToken) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/export/${rowId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       setFileURL(response.data.file_url);
  //       fetchData();
  //       // toast.success("Result CSV has been downloaded successfully.");
  //     } else {
  //       // toast.error("Failed to download the CSV file.");
  //     }
  //   } catch (error) {
  //     const errorMessage =
  //       error.response && error.response.data.message
  //         ? error.response.data.message
  //         : "An error occurred while fetching the data.";
  //     toast.error(errorMessage);
  //     fetchData();
  //   }
  // };

  //   const exportApi = async (decryptedToken) => {
  //   setLoaderOpen(true);
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/export/${rowId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //         },
  //         responseType: "blob",
  //       }
  //     );

  //     if (response.status === 200) {
  //       const blob = new Blob([response.data], { type: "text/csv" });
  //       const url = window.URL.createObjectURL(blob);

  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.download = "exam_questions_export.csv";
  //       document.body.appendChild(link);
  //       link.click();

  //       link.remove();
  //       window.URL.revokeObjectURL(url);

  //       toast.success("CSV downloaded successfully.");
  //       fetchData();
  //     }
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       "An error occurred while fetching the data.";
  //     toast.error(errorMessage);
  //     fetchData();
  //   } finally {
  //     setLoaderOpen(false);
  //   }
  // };

  const exportApi = async (decryptedToken) => {
    setLoaderOpen(true);
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/center_feedback/export/${rowId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
        responseType: "blob",
      });

      if (response.status === 200) {
        const blob = response.data;
        const text = await blob.text();
        try {
          const json = JSON.parse(text);
          if (json.success && json.file_url) {
            const link = document.createElement("a");
            link.href = json.file_url;
            link.setAttribute("download", "center_feedback_questions_export.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.success("CSV downloaded successfully.");
            setLoaderOpen(false);
            return;
          }
        } catch (e) {
          // Not a JSON response, handle directly as a CSV file Blob
        }

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "center_feedback_questions_export.csv");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
        toast.success("CSV downloaded successfully.");
      } else {
        toast.error("Failed to export center feedback questions.");
      }
    } catch (error) {
      toast.error("Export failed");
    } finally {
      setLoaderOpen(false);
    }
  };

  // useEffect(() => {
  //   if (questionList && decryptedToken) {
  //     exportApi(decryptedToken);
  //   }
  // }, [questionList, decryptedToken]);

  const handleExportClick = () => {
    if (decryptedToken) {
      exportApi(decryptedToken);
    } else {
      toast.error("Export file is not available.");
    }
  };

  return (
    <>
      <Loader loaderOpen={loaderOpen} />
      <div className={`${classes.bgwhite} ${classes.boxshadow3}`}>
        <div
          className={`${classes.boxshadow4} ${classes.borderradius6px} ${classes.dflex} ${classes.alignitemscenter} ${classes.justifyspacebetween} ${classes.py0_5} ${classes.px1_5}`}
        >
          <div className={classes.heading}>
            <div className={`${classes.dflex} `}>
              <div className={classes.mr0_5}>
                {" "}
                <QuestionIcon />
              </div>
              <Typography
                variant="h3"
                className={`${classes.fontsize} ${classes.fontfamilyDMSans} ${classes.fw700}`}
              >
                Questions 
              </Typography>
            </div>
            <div className={`${classes.dflex} ${classes.alignitemscenter} `}>
              <Typography
                variant="subtitle1"
                className={`${classes.fontfamilyoutfit} ${classes.fw400} ${classes.fontsize3}`}
              >
                Want to Add in Bulk ?
              </Typography>
              <Button
                onClick={handleDownload}
                className={`${classes.fontfamilyoutfit} ${classes.fw400} ${classes.fw600} ${classes.fontsize3} ${classes.textcolorlink} ${classes.ml0_5}`}
              >
                Download bulk Sample Files
              </Button>
            </div>
          </div>
          <div className={classes.btnContainer}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileInputChange}
              style={{ display: "none" }}
              accept=".xlsx, .csv"
            />
            <Button
              variant="contained"
              color="primary"
              className={classes.transparentbtn}
              onClick={handleUploadClick} // Open the modal on click
            >
              Import CSV File <ImportIcon className={`${classes.ml1}`} />
            </Button>
            <Button
              className={`${classes.custombtnblue} ${classes.ml1}`}
              onClick={handleExportClick}
              type=""
            >
              Export File <ExportIcon className={`${classes.ml1}`} />
            </Button>


          </div>
        </div>
      </div>
    </>
  );
}

export default PageHeader;
